import { InjectionToken } from '@angular/core';

import { OrderRepositoyInterface } from '../../domain/ports/secondary/order-repository.interface';

export const ORDER_REPOSITORY = new InjectionToken<OrderRepositoyInterface>('OrderRepositoyInterface');
